/**
 * Custom tokenizer for Chinese language.
 * Chinese doesn't use spaces between words, so we split by characters
 * while preserving punctuation and spaces as separate tokens.
 *
 * @param {string} text The text to tokenize.
 *
 * @returns {string[]} An array of tokens.
 */
export default function splitIntoTokensCustom(text) {
  if (!text) {
    return [];
  }

  const tokens = [];
  const chineseCharRegex = /[\u4e00-\u9fff]/;
  const whitespaceRegex = /\s/;
  const punctuationRegex = /[.,;:!?()[\]{}'"]/;

  for (let i = 0; i < text.length; i++) {
    const char = text[i];

    if (chineseCharRegex.test(char)) {
      // Chinese character - add as individual token
      tokens.push(char);
    } else if (whitespaceRegex.test(char)) {
      // Whitespace - skip
      continue;
    } else if (punctuationRegex.test(char)) {
      // Punctuation - add as individual token
      tokens.push(char);
    } else {
      // Other characters (like English letters, numbers) - group together
      let word = char;
      while (
        i + 1 < text.length &&
        !chineseCharRegex.test(text[i + 1]) &&
        !whitespaceRegex.test(text[i + 1]) &&
        !punctuationRegex.test(text[i + 1])
      ) {
        i++;
        word += text[i];
      }
      tokens.push(word);
    }
  }

  return tokens.filter(token => token.trim() !== '');
}
